import { Injectable } from '@angular/core'
import { PoUploadAdapter } from './po-upload.adapter'
import { PoUpload } from '../../../models'

@Injectable({
  providedIn: 'root',
})
export class PoUploadConnector {

  constructor (protected adapter: PoUploadAdapter) { }

  post (poUploadForm: PoUpload) {
    return this.adapter.post(poUploadForm)
  }
}
